package io.horion.cv.uiState

import io.horion.cv.api.datasource.common.PersonalInformation
import io.horion.cv.api.datasource.motivation.Letter
import io.horion.cv.api.datasource.motivation.ModelLetter

data class LetterUiState(
    val loading: Boolean = false,
    val letterCreateSuccess: Boolean = false,
    val isConnected: Boolean = true,
    val data : Letter = Letter(
        personalInformation = PersonalInformation()
    ),
    val enterprise : String = "",
    val codePostal : String = "",
    val contact : String = "",
    val ville : String = "",
    val addressEmail : String = "",
    val model :  ModelLetter = ModelLetter.SIMPLE,
    val error: String? = null,
    val success: String? = null,
    val letterTitle : String =  ""
)
